import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const GA_RE = /^G-[A-Z0-9]{4,20}$/;

export const Analytics = () => {
  const { pathname, search } = useLocation();
  const [id, setId] = useState("");
  useEffect(() => {
    let alive = true;
    api.get("/public").then((r) => {
      const v = r.data?.settings?.ga_measurement_id || "";
      if (alive && GA_RE.test(v)) setId(v);
    }).catch(() => {});
    return () => { alive = false; };
  }, []);
  useEffect(() => {
    if (!id || document.getElementById("ga-script")) return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", id, { send_page_view: false });
    const s = document.createElement("script");
    s.id = "ga-script";
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(s);
  }, [id]);
  useEffect(() => {
    if (!id || !window.gtag || pathname.startsWith("/tigasatu")) return;
    const t = setTimeout(() => window.gtag("event", "page_view", { page_path: pathname + search, page_title: document.title, page_location: window.location.href }), 300);
    return () => clearTimeout(t);
  }, [id, pathname, search]);
  return null;
};
